import { render } from "./SearchIcon2.vue?vue&type=template&id=6872f98f&ts=true"
import script from "./SearchIcon2.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchIcon2.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/SearchIcon2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6872f98f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6872f98f', __exports__)) {
    api.reload('6872f98f', __exports__)
  }
  
  module.hot.accept("./SearchIcon2.vue?vue&type=template&id=6872f98f&ts=true", () => {
    api.rerender('6872f98f', render)
  })

}


export default __exports__